import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i7 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i8 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import * as i1 from '@azavista/components/shared';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i5 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import { AzavistaFilterCriteriaComponent, AzavistaFilterCriteriaModule } from '@azavista/components/filter-criteria';
import * as i9 from '@azavista/components/input-field';
import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as i3 from '@angular/material/dialog';
import * as i4 from '@angular/common';
import * as i10 from '@ngx-translate/core';
const _c0 = ["*"];
function AzavistaAdvancedSearchComponent_mat_form_field_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 6)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon", 7);
    i0.ɵɵtext(5, "search");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "input", 8);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵlistener("input", function AzavistaAdvancedSearchComponent_mat_form_field_2_Template_input_input_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onQuickSearchTextChanged($event.target.value));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "QUICK_SEARCH"));
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 6, "QUICK_SEARCH"));
    i0.ɵɵproperty("value", ctx_r1.quickSearchText)("disabled", ctx_r1.searchDisabled);
  }
}
function AzavistaAdvancedSearchComponent_div_3_azavista_input_field_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-input-field", 11);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("valueChanged", function AzavistaAdvancedSearchComponent_div_3_azavista_input_field_1_Template_azavista_input_field_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onFilterItemSelected($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 5, "CHOOSE_SAVED_FILTER"));
    i0.ɵɵproperty("field", ctx_r1.filtersField.field)("value", ctx_r1.filtersField.value)("canEdit", !ctx_r1.searchDisabled)("editMode", !ctx_r1.searchDisabled);
  }
}
function AzavistaAdvancedSearchComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, AzavistaAdvancedSearchComponent_div_3_azavista_input_field_1_Template, 2, 7, "azavista-input-field", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.filtersField.value);
  }
}
function AzavistaAdvancedSearchComponent_div_4_azavista_flat_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 14);
    i0.ɵɵlistener("click", function AzavistaAdvancedSearchComponent_div_4_azavista_flat_button_1_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.editFilter(ctx_r1.selectedFilter));
    });
    i0.ɵɵelementStart(1, "mat-icon", 15);
    i0.ɵɵtext(2, "edit_outline");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "titlecase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("acl", ctx_r1.acl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, i0.ɵɵpipeBind1(5, 2, "EDIT_FILTER")));
  }
}
function AzavistaAdvancedSearchComponent_div_4_azavista_flat_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 14);
    i0.ɵɵlistener("click", function AzavistaAdvancedSearchComponent_div_4_azavista_flat_button_2_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.createNewFilter());
    });
    i0.ɵɵelementStart(1, "mat-icon", 15);
    i0.ɵɵtext(2, "add");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "titlecase");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("acl", ctx_r1.acl);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, i0.ɵɵpipeBind1(5, 2, "CREATE_NEW_FILTER")));
  }
}
function AzavistaAdvancedSearchComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, AzavistaAdvancedSearchComponent_div_4_azavista_flat_button_1_Template, 7, 6, "azavista-flat-button", 13)(2, AzavistaAdvancedSearchComponent_div_4_azavista_flat_button_2_Template, 7, 6, "azavista-flat-button", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedFilter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.selectedFilter);
  }
}
let AzavistaAdvancedSearchService = /*#__PURE__*/(() => {
  class AzavistaAdvancedSearchService {
    constructor(sharedSvc) {
      this.sharedSvc = sharedSvc;
    }
    getDebouncedDistinctObservable(source, interval) {
      return source.pipe(debounceTime(interval), distinctUntilChanged());
    }
    getCriteriaValue(criteria) {
      const value = criteria.operator === "empty" /* FieldOperator.empty */ || criteria.operator === "not_empty" /* FieldOperator.notEmpty */ ? '' : criteria.value;
      return value;
    }
    getAdvancedQueryObjectField(criteria, fieldMode) {
      const objFieldIdentifier = fieldMode === 'name' ? criteria.field.name : criteria.field.id;
      const operator = criteria.operator;
      const value = this.getCriteriaValue(criteria);
      if (operator === "empty" /* FieldOperator.empty */ || operator === "not_empty" /* FieldOperator.notEmpty */) {
        // Both empty and not empty are represented in a same way - they are just placed in different parents
        // Empty is placed as a child of "and" field parent and not empty a child of "not" field parent
        return {
          or: [{
            [objFieldIdentifier]: ''
          }, {
            [objFieldIdentifier]: null
          }]
        };
      } else if (operator === "eq" /* FieldOperator.equal */ || operator === "not_eq" /* FieldOperator.notEqual */) {
        // Equal and not equal are special cases - the values for the fields are not objects but the values themselves
        return {
          [objFieldIdentifier]: value
        };
      } else if (this.sharedSvc.getFieldTypeFromField(criteria.field) === 'text' && (operator === "in" /* FieldOperator.in */ || operator === "not_in" /* FieldOperator.notIn */)) {
        // String type "in' and "notIn" means "contains" and "does not contain" - these will map to "like"
        return {
          [objFieldIdentifier]: {
            like: value
          }
        };
      } else {
        return {
          [objFieldIdentifier]: {
            [operator]: value
          }
        };
      }
    }
    // createAdvancedQuery(criteria: IAdvancedFilterCriteria[], fieldMode: AdvancedQueryFieldIdentifierMode): { [key: string]: any }[] {
    //     const result: any[] = [];
    //     // We must group items by "not" operators and others
    //     const notGroupKey = 'not';
    //     const normalGroupKey = 'normal';
    //     const grouped = this.sharedSvc.getGroups(
    //         criteria,
    //         x => this.isFieldOperatorNot(x.operator, x.field.schema) ? notGroupKey : normalGroupKey);
    //     // Create "normal" group of fields - these that are not "not" type operators
    //     const normalGroup = grouped.find(x => x.key === normalGroupKey);
    //     if (normalGroup) {
    //         for (const normalItem of normalGroup.items) {
    //             const objectField = this.getAdvancedQueryObjectField(normalItem, fieldMode);
    //             result.push(objectField);
    //         }
    //     }
    //     // Create "not" group of fields if exist
    //     // All the items from this group will be placed in "not" object
    //     const notGroup = grouped.find(x => x.key === notGroupKey);
    //     if (notGroup) {
    //         const notObject: any = {};
    //         for (const notItem of notGroup.items) {
    //             const objectField = this.getAdvancedQueryObjectField(notItem, fieldMode);
    //             // "not" is an object, not an array - we should get the name of the only field in the objectField
    //             // and set it to notObject
    //             const objectFieldKey = Object.keys(objectField)[0];
    //             const objectFieldValue = objectField[objectFieldKey];
    //             notObject[objectFieldKey] = objectFieldValue;
    //         }
    //         result.push({ not: notObject });
    //     }
    //     return result;
    // }
    processFilterCreated(filter, filters, advancedFilters, changedData) {
      filters.push(filter);
      const advFilter = this.filterToAdvancedFilter(filter);
      advancedFilters.push(advFilter);
      changedData.createdFilter = advFilter;
    }
    processFilterSaved(filter, filters, advancedFilters, changedData) {
      // Set filter to the changed one
      const filterIndex = filters.findIndex(x => x.id === filter.id);
      if (filterIndex >= 0) {
        filters[filterIndex] = filter;
        const advFilterIndex = advancedFilters.findIndex(x => x.id === filter.id);
        if (advFilterIndex >= 0) {
          advancedFilters[advFilterIndex] = this.filterToAdvancedFilter(filter);
          changedData.savedFilter = advancedFilters[advFilterIndex];
          changedData.selectedFilter = changedData.savedFilter;
        }
      }
      return filters[filterIndex];
    }
    processFilterDeleted(filter, filters, advancedFilters, changedData) {
      // Remove the filter from the list
      const deletedFilterIndex = filters.findIndex(x => x.id === filter.id);
      if (deletedFilterIndex >= 0) {
        filters.splice(deletedFilterIndex, 1);
        const advFilter = advancedFilters.find(x => x.id === filter.id);
        if (advFilter) {
          changedData.deletedFilter = advFilter;
        }
        changedData.selectedFilter = null;
        return true;
      }
      return false;
    }
    advancedFiltersToFilters(advancedFilters) {
      const result = [];
      if (advancedFilters) {
        for (const advFilter of advancedFilters) {
          result.push(this.advancedFilterToFilter(advFilter));
        }
      }
      return result;
    }
    advancedFilterToFilter(advancedFilter) {
      const result = {
        id: advancedFilter.id,
        name: advancedFilter.name,
        criteria: this.advancedFilterCriteriaToFilterCriteria(advancedFilter.criteria)
      };
      if (advancedFilter.isTemporary) {
        result.isTemporary = true;
      }
      return result;
    }
    filterToAdvancedFilter(filter) {
      const result = {
        id: filter.id,
        name: filter.name,
        criteria: this.filterCriteriaToAdvancedFilterCriteria(filter.criteria)
      };
      if (filter.isTemporary) {
        result.isTemporary = true;
      }
      return result;
    }
    filterCriteriaToAdvancedFilterCriteria(filterCriteria) {
      const result = [];
      if (filterCriteria) {
        for (const filter of filterCriteria) {
          result.push({
            field: filter.field,
            operator: filter.operator,
            value: filter.value
          });
        }
      }
      return result;
    }
    advancedFilterCriteriaToFilterCriteria(criteria) {
      const result = [];
      for (const item of criteria) {
        const filterCriteriaItem = {
          field: this.sharedSvc.clone(item.field),
          operator: item.operator,
          allOperators: this.sharedSvc.getAllOperatorsByField(item.field),
          value: item.value
        };
        result.push(filterCriteriaItem);
      }
      return result;
    }
    static {
      this.ɵfac = function AzavistaAdvancedSearchService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaAdvancedSearchService)(i0.ɵɵinject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AzavistaAdvancedSearchService,
        factory: AzavistaAdvancedSearchService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AzavistaAdvancedSearchService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaAdvancedSearchComponent = /*#__PURE__*/(() => {
  class AzavistaAdvancedSearchComponent {
    constructor(sharedSvc, advSearchSvc, matDialog) {
      this.sharedSvc = sharedSvc;
      this.advSearchSvc = advSearchSvc;
      this.matDialog = matDialog;
      this.showQuickSearch = true;
      this.showFilters = true;
      this.fieldMode = 'name';
      this.quickSearchText = '';
      this.selectedAdvancedFilterId = '';
      this.fieldsOptions = [];
      this.changed = new EventEmitter();
      this.searchDisabled = false;
      this.filters = [];
      this.allFieldsConverted = [];
      this.changedData = {
        quickSearchText: '',
        advancedQuery: null,
        createdFilter: null,
        selectedFilter: null,
        deletedFilter: null,
        savedFilter: null,
        filterChanged: false,
        quickSearchTextChanged: false
      };
      this.quickSearchTextChanged = new Subject();
      this.subscriptions = [];
      this.filtersField = {
        field: {
          id: '__filter',
          name: '__filter',
          editable: true,
          schema: {
            type: 'object'
          },
          component: "object_enum" /* FieldComponentType.objectEnum */
        },
        value: null
      };
    }
    ngOnInit() {
      this.subscriptions.push(this.advSearchSvc.getDebouncedDistinctObservable(this.quickSearchTextChanged, 500).subscribe(x => this.emitQuickSearchTextChanged(x)));
      if (this.selectAdvancedFilterSubject) {
        this.subscriptions.push(this.selectAdvancedFilterSubject.subscribe({
          next: filterId => this.processSelectAdvancedFilter(filterId)
        }));
      }
    }
    processSelectAdvancedFilter(filterId) {
      const filter = this.advancedFilters.find(x => x.id === filterId);
      if (filter) {
        this.setSelectedFilter(filter.id);
        this.selectFilter(filter);
        this.refreshFiltersFieldValue(this.filters, filter);
      }
    }
    ngOnDestroy() {
      for (const sub of this.subscriptions) {
        sub.unsubscribe();
      }
    }
    ngOnChanges(changes) {
      if (changes.advancedFilters) {
        // In this.data.advancedFilters we get array of name and array with all selected fields, operator name and the value
        // We need to create another object which will also contain all operators with their availability for the selected field type
        this.filters = this.advSearchSvc.advancedFiltersToFilters(this.advancedFilters);
        this.changedData.selectedFilter = this.selectedAdvancedFilterId && this.advancedFilters?.find(({
          id
        }) => id === this.selectedAdvancedFilterId) || null;
        this.changedData.advancedQuery = null;
        // We must cnovert enum types to array types
        this.allFieldsConverted = this.sharedSvc.convertFieldsForAdvancedFilter(this.allFields);
        this.setSelectedFilter(this.selectedAdvancedFilterId);
        this.refreshFiltersFieldValue(this.filters, this.selectedFilter);
      }
      if (changes.quickSearchText) {
        this.changedData.quickSearchText = changes.quickSearchText.currentValue;
      }
      if (changes.acl) {
        this.searchDisabled = !this.sharedSvc.hasAccess(this.acl);
      }
    }
    refreshFiltersFieldValue(filters, selectedFilter) {
      this.filtersField.value = null;
      window.setTimeout(() => {
        const clonedFilters = [...filters];
        this.filtersField.value = this.sharedSvc.createObjectEnumFieldValueDisplayingName(clonedFilters, selectedFilter?.id);
        this.filtersField.value.items.unshift({
          id: null,
          name: ''
        });
      });
    }
    setSelectedFilter(filterId) {
      if (filterId) {
        const filter = this.filters.find(x => x.id === filterId);
        if (filter) {
          this.selectedFilter = filter;
          this.previousSelectedFilter = filter;
        }
      }
    }
    editFilter(selectedFilter) {
      // Create a copy so original data is not overwritten
      const allFilterNames = this.filters.map(x => x.name);
      const dialogData = this.cloneDialogData({
        filter: selectedFilter,
        allFields: this.allFieldsConverted,
        allFilterNames: allFilterNames,
        isNew: false,
        fieldsOptions: this.fieldsOptions
      });
      const dialogRef = this.matDialog.open(AzavistaFilterCriteriaComponent, {
        data: dialogData,
        minWidth: '50%'
      });
      dialogRef.componentInstance.deleted.subscribe(filter => {
        // Filter delete is requested
        this.processFilterDeleted(filter);
        this.refreshFiltersFieldValue(this.filters, this.selectedFilter);
        dialogRef.close();
      });
      this.setFilterCriteriaComponentInputProperties(dialogRef.componentInstance);
      dialogRef.afterClosed().subscribe(filter => {
        if (filter) {
          // Filter save is requested
          this.processFilterSaved(filter);
          this.refreshFiltersFieldValue(this.filters, this.selectedFilter);
        }
      });
    }
    createNewFilter() {
      const dialogData = {
        filter: {
          id: '' + Date.now(),
          // all entities must have unique id
          criteria: [],
          name: ''
        },
        allFields: this.allFieldsConverted,
        allFilterNames: this.filters.map(x => x.name),
        isNew: true,
        fieldsOptions: this.fieldsOptions
      };
      const dialogRef = this.matDialog.open(AzavistaFilterCriteriaComponent, {
        data: dialogData,
        minWidth: '50%'
      });
      this.setFilterCriteriaComponentInputProperties(dialogRef.componentInstance);
      dialogRef.afterClosed().subscribe(filter => {
        if (filter) {
          this.processFilterCreated(filter);
        }
      });
    }
    setFilterCriteriaComponentInputProperties(component) {
      component.autocompleteInputFieldSearchTextChangedSubject = this.autocompleteInputFieldSearchTextChangedSubject;
      component.autocompleteInputFieldFilterResultSubject = this.autocompleteInputFieldFilterResultSubject;
      component.autocompleteInputFieldsValueIdNameMapping = this.autocompleteInputFieldsValueIdNameMapping;
    }
    processFilterDeleted(filter) {
      const filterRemoved = this.advSearchSvc.processFilterDeleted(filter, this.filters, this.advancedFilters, this.changedData);
      if (filterRemoved) {
        this.selectedFilter = null;
        this.emitChanged(false, true);
      }
    }
    processFilterSaved(filter) {
      const savedFilter = this.advSearchSvc.processFilterSaved(filter, this.filters, this.advancedFilters, this.changedData);
      if (savedFilter) {
        this.selectedFilter = savedFilter;
        this.emitChanged(false, true);
      }
    }
    processFilterCreated(filter) {
      this.advSearchSvc.processFilterCreated(filter, this.filters, this.advancedFilters, this.changedData);
      this.selectedFilter = filter;
      // this.onFilterSelected({ value: filter, source: null });
      this.onFilterItemSelected({
        value: filter
      });
      this.refreshFiltersFieldValue(this.filters, this.selectedFilter);
    }
    cloneDialogData(dialogData) {
      const allFieldsClone = this.sharedSvc.clone(dialogData.allFields);
      const filterClone = this.sharedSvc.clone(dialogData.filter);
      // Reference fields from all fields so they are the same objects - needed for comparison
      for (const item of filterClone.criteria) {
        item.field = allFieldsClone.find(x => x.id === item.field.id);
      }
      const result = {
        allFields: allFieldsClone,
        filter: filterClone,
        isNew: dialogData.isNew,
        allFilterNames: dialogData.allFilterNames
      };
      if (dialogData.fieldsOptions) {
        result.fieldsOptions = this.sharedSvc.clone(dialogData.fieldsOptions);
      }
      return result;
    }
    onQuickSearchTextChanged(value) {
      this.quickSearchTextChanged.next(value);
    }
    emitQuickSearchTextChanged(value) {
      this.changedData.quickSearchText = value;
      this.emitChanged(true, false);
    }
    onFilterItemSelected(args) {
      const filter = args.value;
      if (filter === this.previousSelectedFilter) {
        return;
      }
      this.selectFilter(filter);
    }
    // onFilterSelected(change: MatSelectChange): void {
    //     // TODO: mat-select (onSelectionChange) calls the function twice when an item with undefined value is selected
    //     //       Prevent same filter as previous one to be reported
    //     if (change.value === this.previousSelectedFilter) {
    //         return;
    //     }
    //     this.selectFilter(change.value);
    // }
    selectFilter(filter) {
      this.previousSelectedFilter = filter;
      if (!filter || !filter.id) {
        this.changedData.selectedFilter = null;
        this.selectedFilter = null;
        // this.refreshFiltersFieldValue(this.filters, this.selectedFilter);
        this.emitChanged(false, true);
        return;
      }
      this.selectedFilter = filter;
      const advFilter = this.advancedFilters.find(x => x.id === filter.id);
      if (advFilter) {
        this.changedData.selectedFilter = advFilter;
        // this.refreshFiltersFieldValue(this.filters, this.selectedFilter);
        this.emitChanged(false, true);
      }
    }
    emitChanged(quickSearchTextChanged, filterChanged) {
      if (this.changedData.selectedFilter) {
        this.changedData.advancedQuery = this.sharedSvc.criteriaToSearchParams(this.changedData.selectedFilter.criteria, this.fieldMode);
      }
      this.changedData.quickSearchTextChanged = quickSearchTextChanged;
      this.changedData.filterChanged = filterChanged;
      this.changed.next({
        ...this.changedData
      });
      this.changedData.quickSearchTextChanged = false;
      this.changedData.filterChanged = false;
      this.changedData.advancedQuery = null;
      this.changedData.savedFilter = null;
      this.changedData.deletedFilter = null;
      this.changedData.createdFilter = null;
    }
    static {
      this.ɵfac = function AzavistaAdvancedSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaAdvancedSearchComponent)(i0.ɵɵdirectiveInject(i1.AzavistaSharedService), i0.ɵɵdirectiveInject(AzavistaAdvancedSearchService), i0.ɵɵdirectiveInject(i3.MatDialog));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaAdvancedSearchComponent,
        selectors: [["azavista-advanced-search"]],
        inputs: {
          advancedFilters: "advancedFilters",
          allFields: "allFields",
          showQuickSearch: "showQuickSearch",
          showFilters: "showFilters",
          acl: "acl",
          fieldMode: "fieldMode",
          quickSearchText: "quickSearchText",
          selectedAdvancedFilterId: "selectedAdvancedFilterId",
          fieldsOptions: "fieldsOptions",
          selectAdvancedFilterSubject: "selectAdvancedFilterSubject",
          autocompleteInputFieldSearchTextChangedSubject: "autocompleteInputFieldSearchTextChangedSubject",
          autocompleteInputFieldFilterResultSubject: "autocompleteInputFieldFilterResultSubject",
          autocompleteInputFieldsValueIdNameMapping: "autocompleteInputFieldsValueIdNameMapping"
        },
        outputs: {
          changed: "changed"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c0,
        decls: 7,
        vars: 3,
        consts: [[1, "azavista-advanced-search-component", "advanced-search-container", "aza-cmp-flex-row", "aza-cmp-content-space-between", "aza-cmp-rounded-border", "aza-cmp-full-width"], [1, "advanced-search-controls", "aza-cmp-flex-row"], ["class", "advanced-search-quick-search aza-cmp-medium-width", 4, "ngIf"], ["class", "advanced-search-filters-container", 4, "ngIf"], ["class", "advanced-search-filters-filter-action", 4, "ngIf"], [1, "azavista-advanced-search-component-extra-buttons"], [1, "advanced-search-quick-search", "aza-cmp-medium-width"], ["matPrefix", ""], ["matInput", "", 3, "input", "value", "disabled", "placeholder"], [1, "advanced-search-filters-container"], ["class", "advanced-search-filter-selection", 3, "field", "value", "label", "canEdit", "editMode", "valueChanged", 4, "ngIf"], [1, "advanced-search-filter-selection", 3, "valueChanged", "field", "value", "label", "canEdit", "editMode"], [1, "advanced-search-filters-filter-action"], ["color", "primary", 3, "acl", "click", 4, "ngIf"], ["color", "primary", 3, "click", "acl"], [1, "material-icons-outlined"]],
        template: function AzavistaAdvancedSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, AzavistaAdvancedSearchComponent_mat_form_field_2_Template, 8, 8, "mat-form-field", 2)(3, AzavistaAdvancedSearchComponent_div_3_Template, 2, 1, "div", 3)(4, AzavistaAdvancedSearchComponent_div_4_Template, 3, 2, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showQuickSearch);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showFilters);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showFilters);
          }
        },
        dependencies: [i4.NgIf, i5.AzavistaFlatButtonComponent, i6.MatIcon, i7.MatFormField, i7.MatLabel, i7.MatPrefix, i8.MatInput, i9.AzavistaInputFieldComponent, i4.TitleCasePipe, i10.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AzavistaAdvancedSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaAdvancedSearchModule = /*#__PURE__*/(() => {
  class AzavistaAdvancedSearchModule {
    static {
      this.ɵfac = function AzavistaAdvancedSearchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaAdvancedSearchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaAdvancedSearchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, AzavistaButtonModule, AzavistaFilterCriteriaModule, MatIconModule, MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, AzavistaInputFieldModule]
      });
    }
  }
  return AzavistaAdvancedSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaAdvancedSearchComponent, AzavistaAdvancedSearchModule };
